import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { loadLovableVideoOverrides } from "./data/lovable-video-overrides";
import { loadLovableImageOverrides } from "./data/lovable-image-overrides";

// Fire-and-forget: register Lovable-generated video & image URLs as overrides.
loadLovableVideoOverrides();
loadLovableImageOverrides();

createRoot(document.getElementById("root")!).render(<App />);
